import { render, staticRenderFns } from "./SelectVendor.vue?vue&type=template&id=640198a6&"
import script from "./SelectVendor.vue?vue&type=script&lang=js&"
export * from "./SelectVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports